<script context="module">
  import { fetchWithHeaders, getBaseURL } from "../utils.svelte";

  export async function getCompanyAutocompleteList() {
    const apiResp = await fetchWithHeaders(getBaseURL() + "/company/autocomplete-list");
    return apiResp;
  }
</script>
